// 主题（亮/暗）管理：持久化到 localStorage，落到 <html data-theme="">
// 旧键 vtm-theme 在启动时会把系统暗色偏好也写进去，分不清是不是用户自己选的，
// 所以换新键：只有右上角切换才写入。旧键启动时清掉（真选过暗色的用户需要再切一次）。
const STORAGE_KEY = "vtm-theme-choice";
const LEGACY_KEY = "vtm-theme";

export const THEMES = { LIGHT: "light", DARK: "dark" };

export const getStoredTheme = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === THEMES.DARK || saved === THEMES.LIGHT) {
      return saved;
    }
  } catch (e) {
    /* ignore */
  }
  // 首次访问默认亮色（不再跟随系统暗色偏好：很多客户没选过却进了暗色模式，反馈看不清）
  return THEMES.LIGHT;
};

export const applyTheme = theme => {
  const value = theme === THEMES.DARK ? THEMES.DARK : THEMES.LIGHT;
  document.documentElement.setAttribute("data-theme", value);
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch (e) {
    /* ignore */
  }
  return value;
};

// 启动时只应用不写入：只有用户在右上角切换时才记住选择
export const initTheme = () => {
  try {
    localStorage.removeItem(LEGACY_KEY);
  } catch (e) {
    /* ignore */
  }
  const value = getStoredTheme();
  document.documentElement.setAttribute("data-theme", value);
  return value;
};

export default { THEMES, getStoredTheme, applyTheme, initTheme };
